import { useEffect, useRef } from 'react'
import consumer from '@/channels/consumer'

export function useAllChannelUpdates(
  channelIds: number[],
  selectedChannelId: number | null,
  onNewMessage: (channelId: number) => void
) {
  const onNewMessageRef = useRef(onNewMessage)
  onNewMessageRef.current = onNewMessage

  const selectedRef = useRef(selectedChannelId)
  selectedRef.current = selectedChannelId

  useEffect(() => {
    // Subscribe to all channels except the selected one (which is handled by useChannelMessages)
    const otherChannelIds = channelIds.filter((id) => id !== selectedChannelId)

    const subscriptions = otherChannelIds.map((channelId) =>
      consumer.subscriptions.create(
        { channel: 'Messages::ChannelChannel', channel_id: channelId },
        {
          received(data: { type: string }) {
            if (data.type === 'new_message') {
              onNewMessageRef.current(channelId)
            }
          },
        }
      )
    )

    return () => {
      subscriptions.forEach((sub) => sub.unsubscribe())
    }
  }, [channelIds.join(','), selectedChannelId])
}
